import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NotesService from "../../services/notes.service";

export const getNote = createAsyncThunk(
  "notes/getNote",
  async (payload, thunkAPI) => {
    try {
      const response = await NotesService.getNote(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addNote = createAsyncThunk(
  "notes/addNote",
  async (data, thunkAPI) => {
    try {
      const response = await NotesService.addNote(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateNote = createAsyncThunk(
  "notes/updateNote",
  async (payload, thunkAPI) => {
    try {
      const response = await NotesService.updateNote(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteNote = createAsyncThunk(
  "notes/deleteNote",
  async (id, thunkAPI) => {
    try {
      const response = await NotesService.deleteNote(id);
      return id; 
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  noteslist: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const notesSlice = createSlice({
  name: "notes",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------- Get notes ---------- */
      .addCase(getNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNote.fulfilled, (state, action) => {
        state.loading = false;
        state.noteslist = action.payload?.data || [];
      })
      .addCase(getNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add notes ---------- */
      .addCase(addNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNote.fulfilled, (state, action) => {
        state.loading = false;
        state.noteslist.unshift(action.payload?.data);
      })
      .addCase(addNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update notes ---------- */
      .addCase(updateNote.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateNote.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated = action.payload?.data;
        if (updated?._id) {
          const index = state.noteslist.findIndex(
            (hw) => hw._id === updated._id
          );
          if (index !== -1) {
            state.noteslist[index] = updated;
          }
        }
      })
      .addCase(updateNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
     /* ---------- Delete notes ---------- */
.addCase(deleteNote.pending, (state) => {
  state.loading = true;
  state.error = null;
})

.addCase(deleteNote.fulfilled, (state, action) => {
  state.loading = false;
  state.noteslist = state.noteslist.filter(
    (hw) => hw._id !== action.payload
  );
})

.addCase(deleteNote.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
});

  },
});

export const { resetUpdateStatus } = notesSlice.actions;
export default notesSlice.reducer;
